import React from 'react';
import OwnershipStep from '../00-OwnershipStep';
import LocationStep from '../01-LocationStep';
import DetailsStep from '../02-DetailsStep';
import GeospatialAnalysisStep from '../03-GeospatialAnalysisStep';
import PhotoStep from '../04-PhotoStep';
import FloorPlanStep from '../05-FloorPlanStep';
import ListingStep from '../06-ListingStep';
import DataVerificationStep from '../07-DataVerificationStep';
import AIPriceSuggestionStep from '../08-AIPriceSuggestionStep';
import BuyerVisitScheduleStep from '../09-BuyerVisitScheduleStep';
import SummaryStep from '../10-SummaryStep';
import AgreementPaymentPublishStep from '../11-AgreementPaymentPublishStep';

function WizardStepContent({
  activeStep,
  stepData,
  propertyId,
  listingId,
  onSubmit,
  onPrevious,
}) {
  const sharedProps = {
    onSubmit,
    initialData: stepData[activeStep],
    onPreviousStep: onPrevious,
  };

  switch (activeStep) {
    case 0:
      return <OwnershipStep {...sharedProps} />;
    case 1:
      return <LocationStep {...sharedProps} />;
    case 2:
      return <DetailsStep {...sharedProps} />;
    case 3:
      return <GeospatialAnalysisStep {...sharedProps} locationData={stepData[1]} propertyId={propertyId} />;
    case 4:
      return <PhotoStep {...sharedProps} propertyId={propertyId} />;
    case 5:
      return <FloorPlanStep {...sharedProps} propertyId={propertyId} />;
    case 6:
      return <ListingStep {...sharedProps} propertyId={propertyId} />;
    case 7:
      return <DataVerificationStep {...sharedProps} />;
    case 8:
      return <AIPriceSuggestionStep {...sharedProps} listingData={stepData[6]} listingId={listingId} />;
    case 9:
      return <BuyerVisitScheduleStep {...sharedProps} listingId={listingId} />;
    case 10:
      return <SummaryStep {...sharedProps} propertyId={propertyId} />;
    case 11:
      return <AgreementPaymentPublishStep {...sharedProps} />;
    default:
      return null;
  }
}

export default WizardStepContent;
